export default __webpack_public_path__ + "static/assets/e7a13bc20dc5e8c77d12ff8eb40df70f.png";